import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { CompanyRequest, CompanyResponse } from '../../company.model';
import { SHARED_UTILS } from '@shared/modules/shared-utils.module';

@Component({
  selector: 'company-form',
  imports: [ReactiveFormsModule, ...SharedMaterialUIModule],
  templateUrl: './company-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CompanyFormComponent {
  private readonly formBuilder = inject(FormBuilder);
  readonly utils = SHARED_UTILS();

  readonly title = input('Company form');
  readonly submitLabel = input('Save');
  readonly busy = input(false);
  readonly readOnly = input(false);
  readonly initialValue = input<CompanyResponse | null>(null);
  readonly canToggleActive  = input<boolean>(false);
  readonly companyIsBusy = input<boolean>(false);

  readonly submitted = output<CompanyRequest>();
  readonly deactivateAction = output<string>();

  readonly companyForm = this.formBuilder.group({
    name: ['', Validators.required],
  });

  constructor() {
    effect(() => {
      this.companyForm.reset({ name: this.initialValue()?.name ?? '' });
    });
  }

  protected submit(): void {
    if (this.companyForm.invalid) {
      this.companyForm.markAllAsTouched();
      return;
    }

    this.submitted.emit({ name: this.companyForm.getRawValue().name?.trim() ?? '' });
  }
}
